import BankSummary from './bank-summary';

export default BankSummary;
